// @flow
import BaseCollection from "./BaseCollection";

import type { ModularUIModel, IModelWithChildModels } from "../types";
import type ErrorResponse from "../error/ErrorResponse";
import type LinkModel from "../links/LinkModel";

/**
 * The ResourceCollection makes it possible to add child models to a collection of models
 * These child models are fetched using the ModularUI util
 */
class ResourceCollection<T: IModelWithChildModels> extends BaseCollection<T> {
  /**
   * Retrieve all child model links and flatten it into an array with single entries, removing all undefined items
   */
  getInitialChildModelLinks(): Array<LinkModel> {
    const initialChildModelLinks = [];

    this.collection.forEach((item: T) => {
      // $FlowFixMe[method-unbinding]
      if (typeof item?.getInitialChildModelLinks === "function") {
        initialChildModelLinks.push(...item.getInitialChildModelLinks());
      }
    });

    return initialChildModelLinks;
  }

  /**
   * Pass through models for setchildmodels to items of this collection
   */
  setChildModels(models: Array<ModularUIModel>, errors: Array<ErrorResponse>) {
    this.collection.forEach((item) => {
      // $FlowFixMe[prop-missing]
      if (typeof item["setChildModels"] === "function") {
        item.setChildModels(models, errors);
      }
    });
  }
}

export default ResourceCollection;
